import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/node_modules/.pnpm/@una-ui+content@48.3.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11__9dc049d4e529406bd17655d0053e4735/node_modules/@una-ui/content/layouts/default.vue").then(m => m.default || m))
}